import Yasgui from '@triply/yasgui'
import '../../../node_modules/@triply/yasqe/build/yasqe.min.css'
import { useEffect, useRef } from 'react'
import { useAppCtx } from '@/hooks/use-app-ctx'
import { useLocalSettings } from '@/components/editor/local-settings'
import { GLOBAL_NAMESPACE, usePubsub } from '@/redux/pubsub'
import { resolveTemplateString } from '@/helpers/resolve-template-string'

export function YasguiConsole() {
  const ref = useRef<HTMLDivElement>(null)
  const endpoint = useAppCtx().urlSparql
  const localSettings = useLocalSettings()

  const [ variables ] = usePubsub(GLOBAL_NAMESPACE)
  const variablesRef = useRef(variables)
  useEffect(() => {
    variablesRef.current = variables
  }, [ variables ])

  useEffect(() => {
    if (!ref.current) return
    const yasgui = new Yasgui(ref.current, {
      requestConfig: {
        endpoint,
        withCredentials: true,
        // Yasgui copies adjustQueryBeforeRequest from config.requestConfig into
        // every outgoing request (Tab.initYasqe), so one hook here covers all tabs.
        adjustQueryBeforeRequest: (yasqe: any) =>
          resolveTemplateString(yasqe.getValue(), variablesRef.current),
      }
    })
    return () => yasgui.destroy()
  }, [ endpoint ])

  return (
    <>
      <style>{`
       .yasgui .controlbar input {
          background: white;
          border-radius: .2rem;
          border: 1px solid rgb(222, 226, 230); 
          font-family: "Inter", sans-serif;
       }
       .yasqe .CodeMirror {
          font-family: '${localSettings.fontFamily}', Monaco, Consolas, "Lucida Console", monospace;
          font-size: ${localSettings.fontSize || '14px'};
          font-weight: ${localSettings.fontWeight || '400'};
        }
        .CodeMirror pre.CodeMirror-line {
          line-height: 1.25;
        }
      `}</style>
      <div ref={ref} />
    </>
  )
}
